<div class="grid" *ngIf="loading">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{ 'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<ng-container *ngIf="!loading">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="!isDetail" novalidate id="fFormularioProductoPlazos" name="nomFormularioProductoPlazos">
    <div class="grid form-group">
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'PRODUCTO.LBL_INICIO_RANGO' | translate }}</label>
          <div>
            <input type="text"
                   autocomplete="off"
                   pInputText
                   id="rangoInicial"
                   name="rangoInicial"
                   numero-entero-reactive
                   [maxlength]="4"
                   formControlName="rangoInicial">
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoInicial.errors?.required">
              {{ 'PRODUCTO.LBL_INICIO_RANGO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !f.rangoInicial.errors?.required && form.errors?.rangeSequence">
              {{ 'PRODUCTO.LBL_INICIO_RANGO' | translate }} {{ 'PRODUCTO.LBL_MENOR_A' | translate }} {{ 'PRODUCTO.LBL_FIN_RANGO' | translate }}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !f.rangoInicial.errors?.required && !form.errors?.rangeSequence && form.errors?.rangeOverlap">
              {{ 'PRODUCTO.LBL_ERROR_RANGOS' | translate }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'PRODUCTO.LBL_FIN_RANGO' | translate }}</label>
          <div>
            <input type="text"
                   autocomplete="off"
                   pInputText
                   id="rangoFinal"
                   name="rangoFinal"
                   numero-entero-reactive
                   [maxlength]="4"
                   formControlName="rangoFinal">
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoFinal.errors?.required">
              {{ 'PRODUCTO.LBL_FIN_RANGO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !f.rangoFinal.errors?.required && form.errors?.rangeSequence">
              {{ 'PRODUCTO.LBL_FIN_RANGO' | translate }} {{ 'PRODUCTO.LBL_MAYOR_A' | translate }} {{ 'PRODUCTO.LBL_INICIO_RANGO' | translate }}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !f.rangoFinal.errors?.required && !form.errors?.rangeSequence && form.errors?.rangeOverlap">
              {{ 'PRODUCTO.LBL_ERROR_RANGOS' | translate }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'PRODUCTO.LBL_CANAL' | translate }}</label>
          <p-multiSelect id="idsCanales"
                         name="idsCanales"
                         formControlName="idsCanales"
                         [options]="canalesSelect"
                         [filter]="true"
                         [placeholder]="'LBL_SELECCIONE' | translate"
                         selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         optionValue="value"
                         optionLabel="label"
          ></p-multiSelect>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idsCanales.invalid">
            {{ 'PRODUCTO.LBL_CANAL' | translate }} {{ 'LBL_REQUERIDO' | translate }}
          </div>
        </div>
      </div>
    </div>

    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <div *ngIf="!saving">
          <a (click)="onCancel()" class="cancelar">{{ 'BTN_CANCELAR' | translate }}</a>
          <button icon="fa fa-plus"
                  label="{{( f.idProductoPlazoInversion.value ? 'BTN_ACTUALIZAR' : 'BTN_AGREGAR')  | translate }}"
                  type="submit"
                  pButton>
          </button>
        </div>
        <div *ngIf="saving">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{ 'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>
  </form>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="cols"
               [rows]="10"
               [loading]="saving"
               [value]="productoPlazosInversion"
               [paginator]="true"
               selectionMode="single"
               dataKey="idProductoPlazoInversion"
               paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                class="text-center">
              {{ col.header }}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{ row.rangoInicial }}</td>
            <td>{{ row.rangoFinal }}</td>
            <td>{{ row.canalesNombres }}</td>
            <td class="text-center" *ngIf="!isDetail">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                        title="{{'BTN_INHABILITAR' | translate}}" pButton (click)="onDelete(row)">
                </button>
                <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                        title="{{'BTN_EDITAR' | translate}}" pButton (click)="onEdit(row)">
                </button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ 'MSG_NOHAYREGISTROS' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</ng-container>

<p-confirmDialog #cd key="producto-plazos-inversion">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
